import { BaseRequest } from './BaseRequest';

export class OrganizationRequest extends BaseRequest {
    ApplicationName: string;
    UserIdentity: string;
    OrganizationId: string;
}